<template>
  <validation-provider
    :rules="customRules"
    v-slot="{ errors }"
    :name="name"
    :immediate="false"
    ref="provider"
    :vid="vid"
  >
    <div class="uk-form-icon uk-width-1-1 uk-form-large phone-wrapper">
      <label class="control-label" v-if="label" :aria-label="label">
        {{ label }}
      </label>
      <vue-tel-input
        @country-changed="handleCountryChange"
        @focus="handleBlur"
        @input="handleInput"
        @validate="handleValidate"
        v-model="phoneNumber"
        :class="{
          'flag-right': flagPosition === 'right',
          'uk-form-danger': errors.length,
        }"
        :disabled="disabled"
        :disabledFetchingCountry="disabledFetchingCountry"
        :dropdownOptions="dropdownOptions"
        :inputId="id"
        :inputOptions="inputOptions"
        :maxLen="maxLen"
        :name="name"
        :onlyCountries="countries"
        :placeholder="placeholder || label"
      ></vue-tel-input>
      <i class="bar"></i>
      <span v-show="errors.length" class="error">{{ errors[0] }}</span>
    </div>
  </validation-provider>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    allowValidation: {
      type: Boolean,
      default: true,
    },
    maxLen: {
      type: Number,
      default: 25,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    onlyCountries: {
      type: Array,
      default: undefined,
    },
    disabledFetchingCountry: {
      type: Boolean,
      default: true,
    },
    flagPosition: {
      type: String,
      default: "left",
    },
    rules: {
      required: false,
      default: false,
    },
  },

  data() {
    return {
      blur: false,
      countries: ["US"],
      country: "",
      customRules: {
        required: this.rules,
        regex: /^.{1,}$/,
      },
      dropdownOptions: {
        tabindex: -1,
      },
      id: "_" + Math.random().toString(36).substr(2, 9),
      inputOptions: {
        "aria-describedby": this.label,
      },
      margin: "",
      phoneNumber: "",
    };
  },

  mounted() {
    this.phoneNumber = this.value || "";
  },

  computed: {
    vid() {
      return Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, "")
        .substr(2, 10);
    },
  },

  methods: {
    handleValidate(args) {
      var numberValid = false;
      if (this.allowValidation) {
        if (args.isValid) {
          this.customRules.regex = /^.{6,}$/;
          this.$emit("input", args.number.input);
          numberValid = true;
        } else {
          this.customRules.regex = /^.{36,}$/;
        }
      } else {
        this.customRules.required = false;
      }
      this.$emit("onNumberValid", numberValid);

      if (numberValid) {
        this.$emit("onValidated", args);
      }
    },

    handleInput(number, args) {
      this.country = args.regionCode;
      this.$emit("onInputChange", args);
      this.$emit("input", number);
    },

    handleCountryChange(args) {
      this.country = args.iso2;
      this.$emit("onCountryChange", this.country);
    },

    handleBlur() {
      this.blur = true;
    },
  },

  watch: {
    value: {
      handler(value) {
        this.phoneNumber = value || "";
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
.phone-wrapper .vue-tel-input {
  background: #fff;
  border: 0.0625rem solid #e7e7e7;
  border-radius: 0px;
  input {
    border: none;
    height: 100%;
    line-height: 100%;
    margin-top: 0;
    padding: 7px 10px;
    font-size: 1.2rem;
    &::-webkit-input-placeholder , /* Chrome/Opera/Safari */
      &::-moz-placeholder , /* Firefox 19+ */
      &:-ms-input-placeholder, /* IE 10+ */
      &:-moz-placeholder {
      /* Firefox 18- */
      line-height: 100%;
      height: 100%;
    }
  }
  + .bar:before {
    z-index: 0;
  }
}
</style>
<style lang="scss" scoped>
.flag-right {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
}
</style>
